import React from 'react'
import Skeleton from 'react-loading-skeleton'

const ProductDetailsTabSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl mt-5 mb-10 shadow-sm border border-[#ededed] px-5 md:px-10 py-2 md:py-5 mx-3 md:mx-0">
      {/* Tab headers skeleton */}
      <div className="flex gap-6 border-b border-[#ededed] mb-6">
        {Array(3)
          .fill()
          .map((_, index) => (
            <Skeleton
              key={index}
              width={100 + index * 20}
              height={20}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
          ))}
      </div>

      {/* Tab content skeleton */}
      <div className="space-y-4">
        {Array(6)
          .fill()
          .map((_, index) => (
            <Skeleton
              key={index}
              height={16}
              width={`${90 - index * 5}%`}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
          ))}
      </div>
    </div>
  )
}

export default ProductDetailsTabSkeleton
